export default {
  state: {
    onlineServe: {},
  },
  mutations: {
    setOnlineServe(state, res) {
        console.log('setOnlineServe');
        
      state.onlineServe = res;
    },
  },
  actions: {},
};
